module.exports = __webpack_public_path__ + "static/centrum-rozumu-09ad371e482b19891c2d1e95e8bedac7.png";